import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WithholdingService {

  private url = environment.api;

  constructor(
    private http: HttpClient,
  ) { }

  uploadFile(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);

    return this.http.post(`${this.url}api/inadmin/withholdings/process`, formData);
  }

  getWithholdings(startDate: string, endDate: string) {
    return this.http.get(
      `${this.url}api/erp/withholdings/all?startDate=${startDate}&endDate=${endDate}`
    );
  }

  annulmentWithholding(idWithholding: number): Observable<any> {
    return this.http.delete(
      `${this.url}api/erp/withholdings/anul/${idWithholding}`
    );
  }
}
